import React from "react";

const CARD_BG = {
  completed: "bg-green-50 border-green-200",
  pending:   "bg-amber-50  border-amber-200",
};

const getCardBg = (status) => CARD_BG[status] || "bg-white border-gray-200";

const OrderCards = ({
  filteredOrders,
  selectedSort,
  setPopupOrder,
  setAddress,
  setDriverId,
  setDriverName,
  setDriverMobile,
  setUseNewDriver,
  getStatusColor,
}) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-3 bg-white border border-gray-200 rounded-xl shadow-sm">
    {filteredOrders.length === 0 ? (
      <p className="col-span-full text-sm text-gray-400 p-5 text-center">
        No orders found.
      </p>
    ) : (
      filteredOrders
        .filter((order) => {
          // If no specific status is selected or "all" is selected, show all orders
          if (!selectedSort || selectedSort === "all") return true;
          // Otherwise, filter by the selected status
          if (selectedSort === "completed") return order.status === "completed";
          if (selectedSort === "reject") return order.status === "reject";
          if (selectedSort === "pending") return order.status === "pending";
          if (selectedSort === "accept") return order.status === "accept";
          if (selectedSort === "delivery pickup")
            return order.status === "delivery pickup";
          if (selectedSort === "out for delivery")
            return order.status === "out for delivery";
          return true;
        })
        .map((order) => {
          const orderPlacedTimeStr =
            order.statusHistory?.length > 0
              ? order.statusHistory[0].createdAt
              : order.createdAt;

          let delayMessage = null;
          let diffMinutes = 0;

          if (
            orderPlacedTimeStr &&
            order.status !== "completed" &&
            order.status !== "reject"
          ) {
            const orderPlacedTime = new Date(orderPlacedTimeStr);
            if (!isNaN(orderPlacedTime)) {
              diffMinutes = Math.floor(
                (new Date() - orderPlacedTime) / (1000 * 60),
              );
              if (diffMinutes >= 15) {
                const hours = Math.floor(diffMinutes / 60);
                const minutes = diffMinutes % 60;
                delayMessage =
                  diffMinutes >= 60
                    ? `Delayed for ${hours} hr${hours > 1 ? "s" : ""} and ${minutes} min${minutes !== 1 ? "s" : ""}`
                    : `Delayed for ${diffMinutes} min${diffMinutes !== 1 ? "s" : ""}`;
              }
            }
          }

          const productCount = order.products
            ? order.products.filter((p) => p.active !== false).length
            : 0;

          return (
            <div
              key={order.orderId}
              className={`relative border rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow duration-200 ${getCardBg(order.status)}`}
              onClick={(e) => {
                e.stopPropagation();
                setPopupOrder(order);
                setAddress(order.address || "");
                setDriverId("");
                setDriverName("");
                setDriverMobile("");
                setUseNewDriver(false);
              }}
              onDoubleClick={(e) => e.stopPropagation()}
            >
              <div className="mb-1.5 text-sm text-gray-700">
                <strong>Order ID:</strong> {order.orderId}
                {diffMinutes >= 15 && (
                  <span
                    className={`ml-1 ${diffMinutes > 30 ? "alert-red" : "alert-yellow"}`}
                  >
                    ⚠️
                  </span>
                )}
              </div>
              <div className="mb-1.5 text-sm text-gray-700">
                <strong>Phone:</strong> {order.phoneNumber}
              </div>
              <div className="mb-2 text-sm text-gray-700">
                <strong>Total Products:</strong> {productCount}
              </div>
              <span
                className="mt-1 px-3 py-1 rounded-full text-white font-semibold text-xs inline-block capitalize text-center min-w-[80px]"
                style={{ backgroundColor: getStatusColor(order.status) }}
              >
                {order.status}
              </span>
              {delayMessage && (
                <p className="text-red-600 font-semibold mt-1.5 text-xs">
                  {delayMessage}
                </p>
              )}
            </div>
          );
        })
    )}
  </div>
);

export default OrderCards;
